export default {
  metaTitle: 'Review List',
  excludeSystemAutoGood: 'Exclude System Auto Positive Reviews',
  replyStatus: 'Reply Status',
  noReply: 'no reply',
  replied: 'Replied',
  tabBuyerReviews: 'Buyer Reviews',
  tabPendingBuyerReviews: 'Pending Buyer Reviews',
  contactBuyer: 'Contact Buyer',
  orderCompletedTime: 'Order Completed Time',
  autoGoodRemainingDays: 'Days Until Auto Review',
  autoGoodReviewTip: 'Default positive review in {days} days',
  skuId: 'SKU#',
  operation: 'Operation',
  all: 'All',
  textContent: 'Text Content',
  imageOrVideo: 'Image or video',
  stars: 'Stars',
  filter: 'Filter',
  customerId: 'Customer#',
  productName: 'Product Name',
  orderSn: 'Order#',
  listingId: 'Listing#',
  star: 'Star',
  imageAndVideo: 'Image & Video',
  reviewTime: 'Review Time',
  reply: 'Reply',
  replyColon: 'Reply:',
  replyPlaceholder: 'Please enter reply contents',
  replyTipEmpty: 'Please enter reply contents.',
  buyerIdMissing: 'Buyer ID is missing'
}
